import { environment } from '../../environments/environment';

export const ApiConfig = {
  baseUrl: environment.apiUrl,
  apiKey: environment.apiKey,
  whatsappUrl: environment.whatsapp_url
};